import { render, staticRenderFns } from "./TeamPage.vue?vue&type=template&id=bc4bee7c&scoped=true"
import script from "./TeamPage.vue?vue&type=script&lang=ts"
export * from "./TeamPage.vue?vue&type=script&lang=ts"
import style0 from "./TeamPage.vue?vue&type=style&index=0&id=bc4bee7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4bee7c",
  null
  
)

export default component.exports